const state = {
  dashboardTemplate: {
    topInfoCellTemplate: [
      {
        id: 1,
        name: "Projects",
        modelName: "project_count",
        icon: "mdi-file-table-box-multiple",
        color: "deep-purple",
      },
      {
        id: 2,
        name: "Ticket",
        modelName: "ticket_count",
        icon: "mdi-account-multiple",
        color: "primary",
      },
      {
        id: 3,
        name: "Customers",
        modelName: "customer_count",
        icon: "mdi-account-group",
        color: "teal",
      },
      {
        id: 4,
        name: "Employees",
        modelName: "employee_count",
        icon: "mdi-account-supervisor",
        color: "indigo",
      },
    ],
    bottomInfoCellTemplate: [
      {
        id: 1,
        name: "Projects",
        modelName: "project_trend",
        icon: "mdi-file-table-box-multiple",
        color: "deep-purple",
      },
      {
        id: 2,
        name: "Ticket",
        modelName: "ticket_trend",
        icon: "mdi-account-multiple",
        color: "primary",
      },
      {
        id: 3,
        name: "Customers",
        modelName: "customer_trend",
        icon: "mdi-account-group",
        color: "teal",
      },
      {
        id: 4,
        name: "Employees",
        modelName: "employee_trend",
        icon: "mdi-account-supervisor",
        color: "indigo",
      },
    ],
  },
};
const getters = {
  getDashboardTemplate(state) {
    return state.dashboardTemplate;
  },
};

export default {
  namespaced: true,
  state,
  getters,
};
